.#{$prefix}fullscreen-safari {
  transform: unset !important;
}
